import { OrganizationAclsArray, OrganizationManager } from 'src/careflow/ph-core/admin/organization/type/organization';
import { checkAclValidation } from 'src/careflow/ph-core/admin/permissions/util/permission.utils';
import { getUUID } from 'src/utils/url';
import { apiClient } from 'src/careflow/ph-core/api_client/api_client';
import { TenantService } from 'src/careflow/ph-core/multi-tenant/tenant/service/TenantService';

export async function getOrganization(uuid: string) {
  const data: any = await apiClient.get(`/organizations/${uuid}`);

  return data;
}

export async function getUsersByOrganization(organizationIds: string[], isNull?: boolean) {
  const query = isNull ? '?isNull=true' : '';
  const data: any = await apiClient.get(`/organizations/${organizationIds}/users${query}`);

  return data;
}

export async function createOrganization(payload: OrganizationManager) {
  const data: any = await apiClient.post('/organizations', payload);

  return data;
}

export async function updateOrganization(payload: OrganizationManager, uuid?: string) {
  const data: any  = await apiClient.put(`/organizations/${uuid}`, payload);

  return data;
}

export async function deleteOrganization(uuid: string) {
  const data: any = await apiClient.delete(`/organizations/${uuid}`);

  return data;
}

export async function getOrganizationsByIds(organizationIds: string[]) {
  const data: any  = await apiClient.get(`/organizations/list/${organizationIds}`);

  return data;
}

export async function getOrganizationByAcl(currentUser: any, acls: Partial<OrganizationAclsArray>) {
  const userOrg = getUUID(currentUser?.organization_fhir_uri) ?? "";
  const childOrganizations = currentUser?.organizations?.filter(
    (item: string) => item !== userOrg
  ) ?? [];

  if (acls.all && checkAclValidation({ acls: acls.all })) {
    const allOrgsUsers = await TenantService.getAllOrganizations();
    return allOrgsUsers?.map((item) => item?.fhirId) ?? [];
  }

  const result = new Set<string>();

  if (acls.ownAndChildOrg && checkAclValidation({ acls: acls.ownAndChildOrg })) {
    result.add(userOrg);
    childOrganizations.forEach((org) => result.add(org));
  }

  if (acls.ownOrg && checkAclValidation({ acls: acls.ownOrg })) {
    result.add(userOrg);
  }

  if (acls.childOrg && checkAclValidation({ acls: acls.childOrg })) {
    childOrganizations.forEach((org) => result.add(org));
  }

  return Array.from(result);
}
